import React, { useEffect, useState } from "react";
import { Drawer, Button } from "@mui/material";
import { CheckCircle, Security, Close } from "@mui/icons-material";
import "./PortfolioPaymentPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { useDispatch, useSelector } from "react-redux";
import { userRegistrationSaveEachCardAction } from "../../../actions/MyCertificates/certificatesAction";
import PaymentLoader from "./PaymentLoader";
import { paymentCreateDodoUrlAction } from "../../../actions/Payment/paymentAction";
import { APIRequestURI } from "../../../utils/api_request_uri";
import { getPricingOptionsAction } from "../../../actions/Pricing/pricingActions";
import { getUserRegion } from "../../../utils/change_time_format";
import EducationTopBar from "../topbar/EducationTopBar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useWindowResize from "../../../utils/WindowResize";

const COMPANIES = [
  {
    name: "Google",
    logo: "https://cdn.cdnlogo.com/logos/g/35/google-icon.svg",
  },
  {
    name: "Amazon",
    logo: "https://cdn.cdnlogo.com/logos/a/40/amazon-icon.svg",
  },
  {
    name: "Microsoft",
    logo: "https://cdn.cdnlogo.com/logos/m/84/microsoft-icon.svg",
  },
  { name: "Infosys", logo: "https://cdn.cdnlogo.com/logos/i/48/infosys.svg" },
  {
    name: "TCS",
    logo: "https://cdn.cdnlogo.com/logos/t/6/tata-consultancy-services.svg",
  },
  { name: "Wipro", logo: "https://cdn.cdnlogo.com/logos/w/73/wipro.svg" },
  {
    name: "Accenture",
    logo: "https://cdn.cdnlogo.com/logos/a/73/accenture.svg",
  },
  {
    name: "Capegemini",
    logo: "https://cdn.cdnlogo.com/logos/a/73/accenture.svg",
  },
  {
    name: "HCL",
    logo: "https://cdn.cdnlogo.com/logos/a/73/accenture.svg",
  },
  {
    name: "Netflix",
    logo: "https://cdn.cdnlogo.com/logos/n/59/netflix-icon.svg",
  },
  {
    name: "+120 more",
  },
];

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      fill="#4285F4"
    />
    <path
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.21z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      fill="#EA4335"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="#0a66c2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 21.227.792 22 1.771 22h20.451C23.2 22 24 21.227 24 20.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

const TESTIMONIALS = [
  {
    type: "linkedin",
    name: "Rahul Sharma",
    role: "Software Engineer at Google",
    text: "This portfolio helped me stand out in a sea of resumes. Got 3 interview calls within a week! #CareerGrowth #WebDev",
    avatar: "RS",
    rating: 5,
    date: "1w",
  },
  {
    type: "google",
    name: "Priya Mehta",
    role: "Full Stack Developer",
    text: "Recruiters loved my portfolio. It showcased my projects perfectly and landed me my dream job.",
    avatar: "PM",
    rating: 5,
    date: "1 month ago",
  },
  {
    type: "linkedin",
    name: "Amit Kumar",
    role: "Frontend Dev at Microsoft",
    text: "The best investment I made for my career. Professional and easy to share with recruiters. Highly recommended to all juniors.",
    avatar: "AK",
    rating: 5,
    date: "3d",
  },
  {
    type: "google",
    name: "Sneha Patel",
    role: "Data Analyst",
    text: "My portfolio got noticed by multiple recruiters. Worth every penny! The dark mode design is stunning.",
    avatar: "SP",
    rating: 5,
    date: "2 weeks ago",
  },
  {
    type: "linkedin",
    name: "Karthik Reddy",
    role: "Backend Engineer at TCS",
    text: "Clean, professional, and exactly what recruiters are looking for. If you are looking for a job switch, this is it. 🚀",
    avatar: "KR",
    rating: 5,
    date: "5h",
  },
];

// Helper function to get features based on plan type and items
const getPlanFeatures = (option) => {
  const hasCertification = option.items.some(
    (item) => item.itemType === "Certification",
  );
  const hasPortfolio = option.items.some(
    (item) => item.itemType === "Portfolio",
  );

  if (option.type === "bundle") {
    const certificationItem = option.items.find(
      (item) => item.itemType === "Certification",
    );
    return [
      `${certificationItem?.itemId ? "Professional" : ""} Certification`,
      "Custom portfolio URL",
      "1 year hosting included",
      "Priority email support",
      "SEO optimized profile",
      "Featured on recruiter panels",
    ];
  } else if (option.type === "solo" && hasCertification && !hasPortfolio) {
    return [
      "Professional Certification",
      "Verified digital certificate",
      "LinkedIn shareable",
      "Email support",
      "Lifetime validity",
    ];
  } else if (option.type === "solo" && hasPortfolio) {
    return [
      "Custom portfolio URL",
      "1 year hosting included",
      "Basic analytics dashboard",
      "Email support",
      "SEO optimized profile",
    ];
  }
  return [];
};

// Helper function to get plan label
const getPlanLabel = (option) => {
  const hasCertification = option.items.some(
    (item) => item.itemType === "Certification",
  );
  const hasPortfolio = option.items.some(
    (item) => item.itemType === "Portfolio",
  );

  if (option.type === "bundle") {
    return "BUNDLE PLAN";
  } else if (option.type === "solo" && hasCertification && !hasPortfolio) {
    return "CERTIFICATION ONLY";
  } else if (option.type === "solo" && hasPortfolio) {
    return "PORTFOLIO ONLY";
  }
  return "PLAN";
};

const PricingCard = ({ plan, onPayment }) => {
  const { planType, isPremium, badge, originalPrice, currentPrice, features } =
    plan;

  return (
    <div
      className={`portfoliopaymentpage-pricing-card ${
        isPremium ? "portfoliopaymentpage-premium-card" : ""
      }`}
    >
      {isPremium && badge && (
        <div className="portfoliopaymentpage-premium-badge">{badge}</div>
      )}

      <div className="portfoliopaymentpage-pricing-header">
        <span className="portfoliopaymentpage-plan-label">{planType}</span>
        <div className="portfoliopaymentpage-price-box">
          {originalPrice && (
            <span className="portfoliopaymentpage-price-original">
              ₹{originalPrice}
            </span>
          )}
          <span className="portfoliopaymentpage-price-current">
            ₹{currentPrice}
          </span>
        </div>
      </div>

      <div className="portfoliopaymentpage-features-list">
        {features.map((feature, idx) => (
          <div key={idx} className="portfoliopaymentpage-feature-item">
            <CheckCircle className="portfoliopaymentpage-check-icon" />
            <span>{feature}</span>
          </div>
        ))}
      </div>

      <Button
        className={`portfoliopaymentpage-pay-button ${
          isPremium ? "portfoliopaymentpage-premium-button" : ""
        }`}
        fullWidth
        onClick={() => onPayment(plan)}
      >
        Pay Now
      </Button>

      <div className="portfoliopaymentpage-payment-info">
        <Security fontSize="small" />
        <span>UPI Available • Secure Payment</span>
      </div>
    </div>
  );
};

const TestimonialsSection = () => {
  return (
    <div className="portfoliopaymentpage-testimonials-section">
      <h2 className="portfoliopaymentpage-section-title">
        What People Are Saying
      </h2>

      <div className="portfoliopaymentpage-swiper-container-wrapper">
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={24}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="portfoliopaymentpage-testimonials-swiper"
        >
          {TESTIMONIALS.map((testimonial, idx) => (
            <SwiperSlide key={idx}>
              {testimonial.type === "google" ? (
                <div className="portfoliopaymentpage-testimonial-card portfoliopaymentpage-google-card">
                  <div className="portfoliopaymentpage-google-header">
                    <div className="portfoliopaymentpage-avatar">
                      {testimonial.avatar}
                    </div>
                    <div className="portfoliopaymentpage-google-info">
                      <span className="portfoliopaymentpage-google-name">
                        {testimonial.name}
                      </span>
                      <span className="portfoliopaymentpage-google-meta">
                        {testimonial.role}
                      </span>
                    </div>
                    <div className="portfoliopaymentpage-platform-icon">
                      <GoogleIcon />
                    </div>
                  </div>
                  <div className="portfoliopaymentpage-google-rating-row">
                    <div className="portfoliopaymentpage-rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <span key={i} className="portfoliopaymentpage-star">
                          ★
                        </span>
                      ))}
                    </div>
                    <span className="portfoliopaymentpage-google-date">
                      {testimonial.date}
                    </span>
                  </div>
                  <div className="portfoliopaymentpage-testimonial-text">
                    {testimonial.text}
                  </div>
                </div>
              ) : (
                <div className="portfoliopaymentpage-testimonial-card portfoliopaymentpage-linkedin-card">
                  <div className="portfoliopaymentpage-linkedin-header">
                    <div className="portfoliopaymentpage-avatar">
                      {testimonial.avatar}
                    </div>
                    <div className="portfoliopaymentpage-linkedin-info">
                      <div className="portfoliopaymentpage-linkedin-name-row">
                        <span className="portfoliopaymentpage-linkedin-name">
                          {testimonial.name}
                        </span>
                        <span className="portfoliopaymentpage-connection-degree">
                          · 1st
                        </span>
                      </div>
                      <span className="portfoliopaymentpage-linkedin-role">
                        {testimonial.role}
                      </span>
                      <span className="portfoliopaymentpage-linkedin-date">
                        {testimonial.date} •{" "}
                        <span className="portfoliopaymentpage-globe-icon">
                          🌎
                        </span>
                      </span>
                    </div>
                    <div className="portfoliopaymentpage-platform-icon">
                      <LinkedInIcon />
                    </div>
                  </div>

                  <div className="portfoliopaymentpage-testimonial-text">
                    {testimonial.text}
                  </div>

                  <div className="portfoliopaymentpage-linkedin-footer">
                    <div className="portfoliopaymentpage-reaction-count">
                      <span className="portfoliopaymentpage-reaction-icons">
                        👍 ❤️ 👏
                      </span>
                      <span className="portfoliopaymentpage-count-text">
                        84
                      </span>
                    </div>
                    <div className="portfoliopaymentpage-action-bar">
                      <span>Like</span>
                      <span>Comment</span>
                      <span>Repost</span>
                      <span>Send</span>
                    </div>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default function PortfolioPaymentPage() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const { dodoData } = useSelector((state) => state.paymentCreateDodoUrlStore);
  const { pricingOption } = useSelector(
    (state) => state.getPricingOptionsStore,
  );
  const { success, data: saveCardData } = useSelector(
    (state) => state.userRegistrationEachCardSaveStore,
  );

  const dispatch = useDispatch();
  const isSmallScreen = useWindowResize();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [pricingPlans, setPricingPlans] = useState([]);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 900;
  const companiesCount = isMobile ? 5 : 9;

  useEffect(() => {
    if (dodoData) {
      window.location.href = dodoData.checkoutUrl;
    }
  }, [dodoData]);

  useEffect(() => {
    const eligibleItems = [];

    // If saveCardData exists, add Certification
    if (saveCardData?.originalRegistration?.certification?._id) {
      eligibleItems.push({
        itemType: "Certification",
        itemId: saveCardData.originalRegistration.certification._id,
      });

      // also add Portfolio when certification exists
      eligibleItems.push({
        itemType: "Portfolio",
      });
    } else {
      // If saveCardData is null or undefined, only add Portfolio
      eligibleItems.push({
        itemType: "Portfolio",
      });
    }
    if (userInfo)
      dispatch(
        getPricingOptionsAction({
          eligibleItems,
          country: getUserRegion(),
        }),
      );
  }, [saveCardData, userInfo]);

  // Generate dynamic pricing plans from the unified pricingOption state
  useEffect(() => {
    if (!pricingOption?.options || pricingOption.options.length === 0) {
      setPricingPlans([]);
      return;
    }

    const plans = pricingOption.options.map((option) => {
      const isBundle = option.type === "bundle";
      const planLabel = getPlanLabel(option);
      const features = getPlanFeatures(option);

      return {
        id: option.pricingId,
        _id: option.pricingId,
        planType: planLabel,
        isPremium: isBundle || option.highlight,
        badge: isBundle ? "Bundle" : option.highlight ? "MOST POPULAR" : null,
        originalPrice: null, // Add logic if you have original prices
        currentPrice: option.price,
        features: features,
        dodoProductId: option.dodoProductId,
        itemType: option.type,
        items: option.items,
        currency: option.currency,
      };
    });

    // Sort to show bundle/highlighted plans first
    plans.sort((a, b) => {
      if (a.isPremium && !b.isPremium) return -1;
      if (!a.isPremium && b.isPremium) return 1;
      return 0;
    });

    setPricingPlans(plans);
  }, [pricingOption]);

  const [isProcessing, setIsProcessing] = useState(false);

  const handlePayment = (plan) => {
    setIsProcessing(true);
    const URL = new APIRequestURI().getBaseRedirectURL();

    dispatch(
      paymentCreateDodoUrlAction({
        dodoProductId: plan?.dodoProductId,
        currency: plan?.currency,
        amount: plan?.currentPrice,
        pricingId: plan?._id,
        returnUrl: `${URL}/payment/success`,
      }),
    );

    setDrawerOpen(false);

    setTimeout(() => {
      setIsProcessing(false);
    }, 1000);
  };

  useEffect(() => {
    dispatch(userRegistrationSaveEachCardAction());
  }, [dispatch]);

  const history = useHistory();

  return (
    <div>
      <EducationTopBar
        logo={
          <div
            onClick={() => history.push("/")}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <img
              className={isSmallScreen ? "mobile-logo" : "desktop-logo"}
              src="https://res.cloudinary.com/cqn/image/upload/v1740519381/white_acetechies_logo_vsdhp5.png"
              alt=""
            />
          </div>
        }
      />
      <div className="portfoliopaymentpage-portfolio-page">
        <div className="portfoliopaymentpage-hero-section">
          <h1 className="portfoliopaymentpage-hero-title">
            Your Portfolio is Live and Ready
          </h1>
          <p className="portfoliopaymentpage-hero-subtitle">
            Your personal portfolio has been generated successfully. Students
            just like you have used this to stand out and land interviews.
          </p>
        </div>

        <div className="portfoliopaymentpage-companies-section">
          <h2 className="portfoliopaymentpage-section-title">
            Recruiters Actively Checking Student Portfolios from
          </h2>
          <div className="portfoliopaymentpage-companies-flex">
            <div className="portfoliopaymentpage-companies-grid">
              {[
                ...COMPANIES.slice(0, companiesCount),
                COMPANIES[COMPANIES.length - 1],
              ].map((company, idx) => (
                <div key={idx} className="portfoliopaymentpage-company-card">
                  {company?.logo && (
                    <img
                      src={company.logo}
                      alt={company.name}
                      className="portfoliopaymentpage-company-logo"
                    />
                  )}
                  <span className="portfoliopaymentpage-company-name">
                    {company.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <Button
            className="portfoliopaymentpage-cta-button"
            onClick={() => setDrawerOpen(true)}
          >
            Why Activation Matters
          </Button>
        </div>

        <div className="portfoliopaymentpage-testimonials-section">
          <TestimonialsSection />
          <Button
            className="portfoliopaymentpage-cta-button portfoliopaymentpage-activate-button"
            onClick={() => setDrawerOpen(true)}
          >
            Activate Now
          </Button>
        </div>

        <Drawer
          anchor={`${isMobile ? "bottom" : "right"}`}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{ className: "portfoliopaymentpage-pricing-drawer" }}
        >
          <div className="portfoliopaymentpage-drawer-content">
            <div className="portfoliopaymentpage-drawer-header">
              <span className="portfoliopaymentpage-drawer-title">
                Activate Now for
              </span>
              <Button
                className="portfoliopaymentpage-close-button"
                onClick={() => setDrawerOpen(false)}
              >
                <Close />
              </Button>
            </div>

            {pricingPlans.length > 0 ? (
              pricingPlans.map((plan, index) => (
                <React.Fragment key={plan.id}>
                  <PricingCard plan={plan} onPayment={handlePayment} />
                  {index < pricingPlans.length - 1 && (
                    <div className="portfoliopaymentpage-divider-or">
                      <span className="portfoliopaymentpage-or-text">OR</span>
                    </div>
                  )}
                </React.Fragment>
              ))
            ) : (
              <div style={{ padding: "20px", textAlign: "center" }}>
                Loading pricing plans...
              </div>
            )}
          </div>
        </Drawer>
        <PaymentLoader
          isOpen={isProcessing}
          minDuration={2000}
          onClose={() => {
            console.log("Payment processing UI closed");
          }}
        />
      </div>
    </div>
  );
}
